import { render, staticRenderFns } from "./panel_left.vue?vue&type=template&id=370879c4&scoped=true"
import script from "./panel_left.vue?vue&type=script&lang=js"
export * from "./panel_left.vue?vue&type=script&lang=js"
import style0 from "./panel_left.vue?vue&type=style&index=0&id=370879c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370879c4",
  null
  
)

export default component.exports